import React, { useState } from "react";

import SwipeableItem from 'components/SwipeableItem';

import { SwipeProvider } from 'hoc/SwipeContext';

import "./styles.css";

function List({
    items = [],
    onClickHandler,
    onDeleteHandler,
    onEditHandler
}) {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);


    const getValueString = (item) => {
        switch (item.type) {
            case 'checkbox':
                return item.value === 'checked' ? 'Checked' : 'Not Checked';
        
            default:
                return item.value;
        }
    }

    return (
        <div className="flex-grow-1 overflow-auto">
            <SwipeProvider>
                <ul className="list-group list-group-flush w-100 mb-1">
                    {items.map((item, index) => (
                        <SwipeableItem
                            key={index}
                            id={item.uid || index}
                            onClick={onClickHandler ? () => onClickHandler(item) : null}
                            onEdit={onEditHandler ? () => onEditHandler(item) : null}
                            onDelete={onDeleteHandler ? () => onDeleteHandler(item.uid) : null}
                            className="position-relative overflow-hidden items-swipeable-wrapper"
                        >
                            <li
                                key={index}
                                style={{
                                    cursor: onClickHandler ? "pointer" : "",
                                }}
                                className={`list-group-item d-flex align-items-center w-100 p-1  ${!isMobile ? 'list-group-item-action' : ''}`}
                            >
                                <div style={{
                                    flex: 1,
                                    // padding: '4px'
                                }}>
                                    <div className="d-flex justify-content-between">
                                        <div>{item.name}</div>
                                        <span className="badge bg-secondary">{item.type}</span>
                                    </div>
                            
                                    <div className="d-flex gap-2 mt-1">
                        
                                        {item.payload?.value != null && (
                                            <span className="text-muted small">{getValueString(item)}</span>
                                        )}
                                        {item.payload?.unit && (
                                            <span className="text-muted small">{item.payload.unit}</span>
                                        )}
                                    </div>
                                </div>
                            </li>
                        </SwipeableItem>
                    ))}
                </ul>
            </SwipeProvider>
        </div>
    );
};

export default List;